import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

const Radio = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Radio" pageType="Forms" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Default
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="text-black form-radio"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="default_radio"
                  className="form-radio text-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Square
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-info"
                />
                <span>Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="text-black rounded form-radio"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_radio"
                  className="rounded form-radio text-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Outline
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-purple"
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-black"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_radio"
                  className="form-radio outborder-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Outline Square
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-info"
                />
                <span>Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-black"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="outline_square_radio"
                  className="rounded form-radio outborder-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Outline With Text Color
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-purple"
                />
                <span className="peer-defaultChecked:text-purple">Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-info"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-info">Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-success"
                />
                <span className="peer-defaultChecked:text-success">Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-warning"
                />
                <span className="peer-defaultChecked:text-warning">Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-danger"
                />
                <span className="peer-defaultChecked:text-danger">Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-black"
                />
                <span className="peer-defaultChecked:text-black">Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="rounded_color_radio"
                  className="form-radio peer outborder-muted"
                />
                <span className="peer-defaultChecked:text-muted">Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Radio Outline With Text Color
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-purple"
                />
                <span className="peer-defaultChecked:text-purple">Primary</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-info"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-info">Info</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-success"
                />
                <span className="peer-defaultChecked:text-success">Success</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-warning"
                />
                <span className="peer-defaultChecked:text-warning">Warning</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-danger"
                />
                <span className="peer-defaultChecked:text-danger">Danger</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-black"
                />
                <span className="peer-defaultChecked:text-black">Black</span>
              </label>
              <label className="inline-flex">
                <input
                  type="radio"
                  name="square_color_radio"
                  className="rounded form-radio peer outborder-muted"
                />
                <span className="peer-defaultChecked:text-muted">Muted</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Radio;
